// extracted by mini-css-extract-plugin
export default {"root":"styles_root__Z3zXR","textarea":"styles_textarea__ZDllx","textareaError":"styles_textareaError__MNXo-","textarea_max_length":"styles_textarea_max_length__LIaKL"};